import { render, staticRenderFns } from "./UserChangePasswordDialog.vue?vue&type=template&id=4e361c1a&scoped=true&"
import script from "./UserChangePasswordDialog.vue?vue&type=script&lang=ts&"
export * from "./UserChangePasswordDialog.vue?vue&type=script&lang=ts&"
import style0 from "./UserChangePasswordDialog.vue?vue&type=style&index=0&id=4e361c1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e361c1a",
  null
  
)

export default component.exports